import { AgentInput } from "@fidget/common/components/form/agentInput";
import {
  AutoComplete,
  AutoCompleteProps
} from "@fidget/common/components/form/autoComplete/autoComplete";
import { intl } from "@fidget/common/i18n";
import { caseInsensitiveIncludes } from "@fidget/common/utils/searchMatching";
import classNames from "classnames";
import { FieldState } from "formstate";
import { observer } from "mobx-react";
import React, { useState } from "react";
import { IAgentGroup } from "../../../models/agentGroups/agentGroup";
import settingsStyles from "../../../styles/settings.css";

interface Props extends Partial<AutoCompleteProps<IAgentGroup>> {
  values: IAgentGroup[];
}

export const AgentGroupPicker = observer(function AgentgroupPicker({
  onChange,
  values,
  className,
  placeholder = intl.formatMessage("agentGroupPicker.placeholder"),
  ...autoCompleteProps
}: Props) {
  const [inputField] = useState(new FieldState(""));

  return (
    <AutoComplete<IAgentGroup>
      {...autoCompleteProps}
      readOnly
      onChange={onChange}
      itemsProvider={
        inputField.$
          ? () => values.filter((tag) => caseInsensitiveIncludes(tag.name, inputField.$))
          : () => values
      }
      itemToString={(val) => val?.name || ""}
      emptyPlaceholder={intl.formatMessage("agentGroupPicker.empty")}
      placeholder={placeholder}
      className={classNames(settingsStyles["input-max-width-bigger"], className)}
    >
      <AgentInput
        field={inputField}
        placeholder={intl.formatMessage("agentGroupPicker.input.placeholder")}
      />
    </AutoComplete>
  );
});
